// extracted by mini-css-extract-plugin
export default {"file-form":"FileForm_file-form__pF3U8"};